<template>
<div class="c-multi-hero" :id="id">
    <div class="c-multi-hero__nav" :aria-controls="`${id}-content`">
        <button type="button" :id="`${id}-button${index}`" :aria-pressed="(selected === index) ? 'true' : 'false'" @click="setSelected(index)" class="c-multi-hero__nav-item" v-for="(teaser, index) in teasers" v-if="index < 3" :key="index">
			<span class="c-multi-hero__nav-item-text">
				<span class="c-multi-hero__nav-item-heading">{{(teaser.navHeading) ? teaser.navHeading : teaser.heading}}</span>
				<span class="c-multi-hero__nav-item-tagline">{{(teaser.navTagLine) ? teaser.navTagLine : teaser.tagline}}</span>
			</span>
			<span class="c-multi-hero__nav-item-icon">
				<span></span>
			</span>
        </button>
    </div>
    <div class="c-multi-hero__content" :id="`${id}-content`" aria-live="polite" aria-atomic="true" :aria-labelledby="`${id}-button${selected}`" :style="`background-image: url('${currentTeaser.image}')`">
        <div class="c-multi-hero__content-text">
            <p class="c-multi-hero__content-heading">
                {{currentTeaser.heading}}
            </p>
            <p class="c-multi-hero__content-tagline">
                {{currentTeaser.tagline}}
            </p>
            <a v-if="currentTeaser.link && currentTeaser.linkText" :href="currentTeaser.link" class="c-button c-button--icon c-button--highlight">
                <span class="c-button--right">{{currentTeaser.linkText}}</span>
                <v-icon name="icon-arrow-circle"></v-icon>
            </a>
        </div>
		<!-- Removed due to comment in MKB-384 -->
		<!-- <div class="c-multi-hero__content-image-overlay"></div> -->
    </div>
</div>
</template>

<script>
import VIcon from '../../components/icon/VIcon.vue';
export default {
    name: 'VMultiHero',
    components: {
        VIcon
    },
    props: {
		id: {
			type: String,
			default: 'multihero'
		},
        teasers: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selected: 0
        }
    },
    computed: {
        currentTeaser() {
            return this.teasers[this.selected];
        }
    },
    methods: {
        setSelected(index) {
            this.selected = index;
        }
    },
}
</script>
